import { useCallback, useEffect, useState, Fragment } from "react";
import LoadingCM from "components/shared/Loading";
import {
  StyledCardContent,
  StyledTypographyContent,
  StyledImage,
  StyledLink,
} from "./Styles.style";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import useHttp from "hooks/use-http";
import { getbranchRequest } from "api/requests";
import Container from "@mui/material/Container";
import MenuCM from "components/shared/menu";
import { Grid } from "@mui/material";
import Alert from "@mui/material/Alert";
import FooterCM from "components/shared/footer";
import ContactCM from "components/contactus";
import parse from "html-react-parser";
import {Helmet} from "react-helmet";

export default function About() {
  const { request, loading } = useHttp();
  const [text, setText] = useState("");

  const getContent = useCallback(async () => {
    let res = await request({
      url: getbranchRequest,
      values: {},
    });
    setText(res);
  }, [request]);

  useEffect(() => {
    getContent();
  }, [getContent]);

  return (
    <div>
      <Helmet>
        <title>شعبات حضوری - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="شعبات حضوری" />
          <Container>
            <Card
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                borderRadius: "15px",
              }}
            >
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  شعبات حضوری
                </Typography>
              </StyledCardContent>

              <CardContent>
                <StyledTypographyContent
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  {text && parse(text?.text)}
                </StyledTypographyContent>
              </CardContent>
            </Card>
            <Alert
              severity="info"
              sx={{ marginBottom: "30px", marginTop: "30px" }}
            >
              برای برقراری ارتباط با مدیران شرکت تولیدی نگين کاج شمال روی لینک
              مقابل کلیک کنید.
              <StyledLink to="/contact">ارتباط با ما</StyledLink>
            </Alert>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
